import EditBlogContainer from "../containers/EditBlogContainer";

const EditBlogPage = () => {
  return (
    <EditBlogContainer />
  );
};

export default EditBlogPage;
